import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { EmailFieldProps } from "./EmailField.types";

/** Email editable field. */
export function EmailField({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  error,
  className,
  placeholder,
  helpText,
}: EmailFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <input
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        type="email"
        className={fieldControlClass("form-control", error)}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
      />
    </FieldValue>
  );
}
